import { render, staticRenderFns } from "./DialogCreateCriteria.vue?vue&type=template&id=3231ad28"
import script from "./DialogCreateCriteria.vue?vue&type=script&lang=js"
export * from "./DialogCreateCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports